// src/App.js
import React from 'react';
import Survey from './Survey';
import './styles.css';

function App() {
  return (
    <div className="App">
      <h1>Kurtlar Vadisi'nde hangi karaktersin?</h1>
      <Survey />
      
    </div>
  );
}

export default App;
